import React from "react";
import { Slide, Heading } from "spectacle";
import FunctionView from "../components/FunctionView";
import AlgorithmGraph from "../components/AlgorithmGraph";
import { f, df, x, y, x0 } from "../util/function";
import animations from "../util/animations";

const maxPoint = x[1] - 0.02;
class BuildGraph extends React.Component {
  state = {
    x: x[1],
    point: false
  };
  componentDidMount() {
    animations.add(this, {
      key: "x",
      min: x[0],
      max: maxPoint,
      length: 30000,
      ease: animations.easing.cubic,
      onEnd: () => {
        this.setState({ x: x[1], point: maxPoint });
        animations.add(this, {
          key: "point",
          min: maxPoint,
          max: x0,
          ease: animations.easing.cubic,
          length: 5000
        });
      }
    });
  }

  componentWillUnmount() {
    animations.remove(this);
  }

  render() {
    const point = this.state.point ? this.state.point : this.state.x;
    return (
      <div style={{ position: "relative" }}>
        <div
          style={{
            position: "absolute",
            top: "20%",
            right: "-22%",
            width: "100%",
            textAlign: "center"
          }}
        >
          <Heading size={3}>
            <FunctionView animated={false} x={point} f={f} />
          </Heading>
        </div>
        <AlgorithmGraph
          f={v => (v <= this.state.x ? f(v) : null)}
          df={df}
          x={x}
          y={y}
          points={[
            {
              x: point,
              step: 0
            }
          ]}
          keyPoints={[this.state.x]}
        />
      </div>
    );
  }
}

export default [
  <Slide>
    <Heading size={3}>Een functie</Heading>
    <Heading size={2}>
      <FunctionView f={f} />
    </Heading>
  </Slide>,
  <Slide>
    <BuildGraph />
  </Slide>
];
